import type { PosSalesByCurrencyReportQueryDTO } from "@/modules/merchant/domain/contracts";

/** Query ວ່າງ — ໃຊ້ຮ່ວມລະຫວ່າງແດຊບອດ ແລະ ສ່ວນລາຍງານເພື່ອ key/cache ດຽວກັນ */
export const EMPTY_POS_SALES_CURRENCY_QUERY: Partial<PosSalesByCurrencyReportQueryDTO> =
  {};
